import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export function useUnreadTickets() {
  const [unreadCount, setUnreadCount] = useState<number>(0);

  useEffect(() => {
    loadUnreadCount();

    // Set up real-time subscription for ticket updates
    const channel = supabase
      .channel('admin-unread-tickets')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'feature_requests'
        },
        () => {
          loadUnreadCount();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const loadUnreadCount = async () => {
    try {
      const { data: tickets, error } = await supabase
        .from('feature_requests')
        .select('id, updated_at, admin_read_at, created_at');

      if (error) throw error;

      // Count tickets that are either:
      // 1. Never read by admin (admin_read_at is null)
      // 2. Updated after admin read them (updated_at > admin_read_at)
      const unread = tickets?.filter(ticket => 
        !ticket.admin_read_at || 
        new Date(ticket.updated_at) > new Date(ticket.admin_read_at)
      ).length || 0;

      setUnreadCount(unread);
    } catch (error) {
      console.error('Error loading unread count:', error);
    }
  };

  return unreadCount;
}
